export const Response = {
    DEFAULT: 0,
    AWAITING: 1,
    ACCEPTED: 2,
};
